// src/main.ts
import { normalizeLegacyAutoplayEvents } from "./utils/autoplayPolicy";
import { enableDebugLogging, log } from "./utils/debug";

if (window.location.search.includes("debug")) {
  enableDebugLogging();
}

// Initialize CDN monitor early if enabled via query param or config
if (typeof window !== "undefined") {
  (async () => {
    const { initCdnMonitor } = await import("./utils/cdnMonitor");
    // Enable monitoring if debug mode or if meta tag says so
    const shouldMonitor = window.location.search.includes("debug") ||
      document.querySelector('meta[name="storycore-enable-cdn-monitor"]');
    
    if (shouldMonitor) {
      initCdnMonitor({
        enableConsoleLogging: true,
        enableLocalStorage: true,
      });
    }
  })().catch(err => {
    console.warn("[MAIN] Failed to initialize CDN monitor:", err);
  });
}

// Ensure autoplay event normalization runs before anything else.
if (typeof window !== "undefined" && typeof document !== "undefined") {
  normalizeLegacyAutoplayEvents(); // idempotent
}

document.addEventListener("DOMContentLoaded", async () => {
  log("[MAIN] DOM loaded. Initializing StoryCore...");
  // Load core only after normalization is in place.
  const { initStoryCore } = await import("./core/core");
  initStoryCore();
});